
import { Component } from '@angular/core';
import { ApiService } from 'src/app/api.service';
import { CommonModule } from '@angular/common';
import { Router } from '@angular/router';

@Component({
  selector: 'app-linha-produtos',
  templateUrl: './linha-produtos.component.html',
  styleUrl: './linha-produtos.component.scss'
})
export class LinhaProdutosComponent {
  categories: any;


  constructor(
    private apiService: ApiService,
    private route: Router
  ) { }

  async ngOnInit(): Promise<void> {
    await this.loadCategories();
  }

  async loadCategories(): Promise<void> {
    const result = await this.apiService.loadCategories();
    this.categories = result;
  }
  goToCategoriesDetail(slug: string){
    this.route.navigate([`linhas/${slug}`])
  }
}


